export default __webpack_public_path__ + "static/media/10.43eec298.jpg";